module.exports = __webpack_public_path__ + "static/media/rafiki_rv.dce0032c.svg";